var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHastag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.935,
    height: 12.935,
    viewBox: "0 0 12.935 12.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hastag",
    d: "M12.4,3.773H9.8L10.236.612A.539.539,0,1,0,9.167.466L8.717,3.773H4.954L5.385.612A.539.539,0,0,0,4.317.466L3.866,3.773H1.078a.539.539,0,1,0,0,1.078H3.719L3.278,8.084H.539a.539.539,0,0,0,0,1.078H3.131L2.7,12.323a.539.539,0,1,0,1.068.146l.451-3.307H7.982L7.55,12.323a.539.539,0,0,0,1.068.146l.451-3.307h2.788a.539.539,0,0,0,0-1.078H9.216l.441-3.234H12.4a.539.539,0,1,0,0-1.078ZM8.129,8.084H4.366l.441-3.234H8.57Z",
    transform: "translate(0 0)",
    fill: "#ff643a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHastag);
export default __webpack_public_path__ + "static/media/hastag.bad8957ceb9230a0b03e2f9527502389.svg";
export { ForwardRef as ReactComponent };